export default __webpack_public_path__ + "static/media/02.8ec67607.png";